/**
 * Firebase sends password-reset and "undo 2-step verification" links to one configured action
 * URL. If that link lands on another auth page (register, login, the verify-email screen), the
 * user sees no way to set a password (TCK-00483, TCK-00515). Only /auth/resetpass handles these
 * modes, so they are forwarded there with their query intact. Email-verification links keep
 * their existing flow.
 */
const RESET_PAGE_MODES = ['resetPassword', 'revertSecondFactorAddition']

export const RESET_PAGE_PATH = '/auth/resetpass'

export function firebaseActionTarget(pathname: string, search: string): string | null {
  if (pathname === RESET_PAGE_PATH) return null
  const params = new URLSearchParams(search)
  const mode = params.get('mode')
  if (!mode || !params.get('oobCode') || !RESET_PAGE_MODES.includes(mode)) return null
  return `${RESET_PAGE_PATH}?${params.toString()}`
}
